import { AdTemplate } from "@models/AdTemplate.model";
import { httpRequest } from "../../../shared/services/http";
import { AdTemplateSerializer } from "@models/serializers/adTemplateSerializer";

export class CommandCreateTemplateChild {
  async run(parentId: number, templateName: string) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ad_templates/${parentId}/create/`;
    try {
      const response = await httpRequest(url, {
        method: "POST",
        body: { name: templateName, description: "" },
      }).catch((err) => console.log(err));

      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): AdTemplate {
    return new AdTemplateSerializer().deserialize(data);
  }
}
